/**
 * An SVG group whose contents answer a touch-and-hold the way they answer a
 * right-click.
 *
 * A component rather than the hook used directly, because the things on the
 * bench that need this — the two layers of every column's stand — are rendered
 * inside a `map`, and a hook cannot be called there.
 */
import { useLongPress } from '../useLongPress';

export function LongPressGroup({
    open, children,
}: {
    /** Show the menu for whatever this group draws, at the point pressed. */
    open: (clientX: number, clientY: number) => void;
    children: React.ReactNode;
}): React.JSX.Element {
    return <g {...useLongPress(open)}>{children}</g>;
}
